import { useContext, useState } from 'react';
import ModalCenter from '../../../components/modal/modalCenter';
import styles from './modalReconexion.module.css'
import Btn from '../../../components/btn/btn';
import ApiFetch from '../../../utils/fetch';
import SwalAlert from '../../../utils/swalAlert';
import Swal from 'sweetalert2';
import { Alert, TextField } from '@mui/material';
import Loading from '../../../components/loading/loading';
import { AppContext } from '../../../context/context';
import inputControl from '../../../utils/inputControl'


const fetch = new ApiFetch();
const alert = new SwalAlert();

const alertDeuda = (text) => {
    Swal.fire({
        text:text,
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Pagar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          window.open("https://cooppagos.coop5.com.ar/");
        }
      });
}


const ModalReconexion = ({ idPrestacion, servicio, getServices, idServicio }) => {
    const {sessionExpired} = useContext(AppContext)
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState('');
    const [email, setEmail] =  useState('')
    const [validateEmail, setValidateEmail] =  useState(false)
    const isEnergiaOAgua = [1,2].includes(idServicio) ? true : false
    const horasReconexion = [1,2].includes(idServicio) ? '48' : '24'
  
    const getEstadoDeuda = async () => {
        try {
            setLoading(<Loading/>)
            const data = await fetch.GET(`/reconexion/getEstadoDeuda/${idPrestacion}`);
            setLoading('')
            const status = data?.status;
            const message = data?.message

              switch (status) {
                case 200:
                    if (message === 'OK'){
                        setShow(true)   
                    } else {
                        alertDeuda(message)
                    }
                      break;
                  case 401:
                      sessionExpired(message)
                      break;
                default:
                    alert.warning(message)
                    break;
            }
        } catch (error) {
            setLoading('')
            alert.error('Hubo un error, por favor intente nuevamente más tarde.')
        }
    }

    const handleChangeEmail = (e, setStatus) => {
        const value = e.target.value
        const validate = inputControl.email(value)
        if (!validate && value.length > 0){
          setValidateEmail(false)
        } else {
          setValidateEmail(true)
        }
        setStatus(value)
    }


    const reconectar = async () => {
        try {
            if (isEnergiaOAgua && !email){
                alert.warning('Debe ingresar su Correo Electrónico.');
                return;
            }
            if (isEnergiaOAgua && !validateEmail){
                alert.error('El Correo ingresado no es válido.');
                return;
            }
            setLoading(<Loading/>)
            const body = JSON.stringify({idPrestacion, email})
            const data = await fetch.POST(body, '/reconexion/reconectar')
            setEmail('')
            setValidateEmail(false)
            setLoading('')
            const status = data?.status;
            const message = data?.message;
            if (status === 401) {
                sessionExpired(message)
                return;
            }
            if (status === 201) {
                setShow(false)
                alert.success(message)
                await getServices();
            } else {
                setShow(false)
                 alert.error(message)
            }
        } catch (error) {
            setShow(false)
            setLoading('')
            alert.error('No fue posible realizar la reconexión, por favor intente nuevamente más tarde.')
        }
    }

    return(
        <>
        <Btn action={()=>getEstadoDeuda()} text='Reconectar' color='success' />
            <ModalCenter  show={show} setShow={setShow} title={`Reconexion de ${servicio}`}>
                <div className={styles.container}>
                <Alert severity='warning'> 
                <b>Importante:</b> luego de realizar el trámite de reconexión, su servicio será restablecido en un plazo máximo de <b>{horasReconexion} hs.</b> Tenga en cuenta que el costo de reconexión se verá reflejado en su
                próxima factura.
                </Alert>
               {isEnergiaOAgua && <TextField color={validateEmail && email && 'success'} helperText={!validateEmail && email && 'No es un correo válido.'} error={!validateEmail && email ? true : false} value={email} onChange={(e)=>handleChangeEmail(e,setEmail)} size='small' label='Ingrese su Correo Electrónico' />} 
                <p>¿ Está seguro de que desea reconectar el servicio de<b> {servicio}</b>?</p>
                    <div className={styles.buttonContainer}>
                    <Btn action={()=>setShow(false)} color='error'  variant='text' text='Cancelar'/>
                    <Btn action={()=>reconectar()} color='success' text='Reconectar' />
                    </div>
                </div>
            </ModalCenter>
            {loading}
        </>
    )
}

export default ModalReconexion;